import { EPSG } from "../Models/EPSG";
import { TimezoneItem } from "../Models/TimezoneItem";

export const locales = [
  { id: "en", label: "English" },
  { id: "de", label: "Deutsch" },
  { id: "fr", label: "Français" },
  { id: "cs", label: "Čeština" },
  { id: "fi", label: "Suomeksi" },
];

export enum Unit {
  Meter = 0,
  Foot = 1,
}

export const CountriesCodes: string[] = [
  "Undefined",
  "AD",
  "AT",
  "AQ",
  "AU",
  "BA",
  "BG",
  "CA",
  "CH",
  "CN",
  "CZ",
  "DE",
  "DK",
  "ES",
  "FI",
  "FR",
  "GB",
  "GL",
  "HR",
  "HU",
  "IT",
  "JP",
  "KR",
  "KZ",
  "LI",
  "NO",
  "NZ",
  "PL",
  "RO",
  "SA",
  "SE",
  "SI",
  "SK",
  "SRB",
  "US",
  "UA",
];

export enum FilterOptions {
  Name = "Name",
  Country = "Country",
  Customer = "Customer",
  LicenseExpiration = "LicenseExpiration",
  None = "None",
}

export enum LicenseCodes {
  TrialBasic = 1,
  Trial = 2,
  Core = 4,
  SnowManagement = 8,
  TaskAndRescue = 16,
  Interface = 32,
  SmartZone = 64,
  OEMLegacy = 128,
}

export enum LicenseCodesAddOns {
  SnowManagement,
  TaskAndRescue,
  Interface,
  SmartZone,
}

export enum AppTypes {
  LengthProfileApp = 0,
  OwnerAnalysisApp = 1,
  ReportsApp = 2,
  SnowAnalysisApp = 3,
  SnowgunApp = 4,
  TelevisionApp = 5,
  TimeLapseApp = 6,
  VehicleTrackingApp = 7,
  WMSApp = 8,
  MeteoApp = 9,
  TasksApp = 10,
  MobileApp = 11,
}

export enum ModeModelErrorType {
  Original,
  FilterNegativ,
  NegativIsZero,
}

export const EPSGCodes: EPSG[] = [
  { code: 2056, name: "CH1903+ / LV95", country: "Switzerland" },
  { code: 2110, name: "NZGD2000 / Tuhirangi 2000", country: "New Zealand" },
  { code: 2127, name: "NZGD2000 / Lindis Peak 2000", country: "New Zealand" },
  { code: 2154, name: "RGF93 v1 / Lambert-93", country: "France" },
  { code: 2177, name: "ETRF2000-PL / CS2000/18", country: "Poland" },
  { code: 2450, name: "JGD2000 / Japan Plane Rectangular CS VIII", country: "Japan"},
  { code: 2772, name: "NAD83(HARN) / Colorado North", country: "USA" },
  { code: 2828, name: "NAD83(HARN) / New York East", country: "USA" },
  { code: 2949, name: "NAD83(CSRS) / MTM zone 7", country: "Canada" },
  { code: 2950, name: "NAD83(CSRS) / MTM zone 8", country: "Canada" },
  { code: 3006, name: "SWEREF99 TM", country: "Sweden" },
  { code: 3008, name: "SWEREF99 13 30", country: "Sweden" },
  { code: 3044, name: "ETRS89 / UTM zone 32N (N-E)", country: "World" },
  { code: 3067, name: "ETRS89 / TM35FIN(E,N)", country: "Finland" },
  { code: 3702, name: "NAD83(NSRS2007) / Wyoming East", country: "USA" },
  { code: 3857, name: "WGS 84 / Pseudo-Mercator", country: "World" },
  { code: 3943, name: "RGF93 v1 / CC43", country: "France" },
  { code: 3944, name: "RGF93 v1 / CC44", country: "France" },
  { code: 3945, name: "RGF93 v1 / CC45", country: "France" },
  { code: 3946, name: "RGF93 v1 / CC46", country: "France" },
  { code: 5514, name: "S-JTSK / Krovak East North", country: "Czechia/Slovakia"},
  { code: 5950, name: "ETRS89 / NTM zone 10 + NN2000 height", country: "Norway"},
  { code: 6427, name: "NAD83(2011) / Colorado Central", country: "USA" },
  { code: 6429, name: "NAD83(2011) / Colorado North", country: "USA" },
  { code: 6524, name: "NAD83(2011) / New Hampshire", country: "USA" },
  { code: 21781, name: "CH1903 / LV03", country: "Switzerland" },
  { code: 25832, name: "ETRS89 / UTM zone 32N", country: "World" },
  { code: 28355, name: "GDA94 / MGA zone 55", country: "Australia" },
  { code: 31254, name: "MGI / Austria GK West", country: "Austria" },
  { code: 31255, name: "MGI / Austria GK Central", country: "Austria" },
  { code: 31468, name: "DHDN / 3-degree Gauss-Kruger zone 4", country: "Germany"},
  { code: 32145, name: "NAD83 / Vermont", country: "USA" },
  { code: 32610, name: "WGS 84 / UTM zone 10N", country: "World" },
  { code: 32611, name: "WGS 84 / UTM zone 11N", country: "World" },
  { code: 32612, name: "WGS 84 / UTM zone 12N", country: "World" },
  { code: 32613, name: "WGS 84 / UTM zone 13N", country: "World" },
  { code: 32614, name: "WGS 84 / UTM zone 14N", country: "World" },
  { code: 32615, name: "WGS 84 / UTM zone 15N", country: "World" },
  { code: 32616, name: "WGS 84 / UTM zone 16N", country: "World" },
  { code: 32617, name: "WGS 84 / UTM zone 17N", country: "World" },
  { code: 32618, name: "WGS 84 / UTM zone 18N", country: "World" },
  { code: 32619, name: "WGS 84 / UTM zone 19N", country: "World" },
  { code: 32629, name: "WGS 84 / UTM zone 29N", country: "World" },
  { code: 32630, name: "WGS 84 / UTM zone 30N", country: "World" },
  { code: 32631, name: "WGS 84 / UTM zone 31N", country: "World" },
  { code: 32632, name: "WGS 84 / UTM zone 32N", country: "World" },
  { code: 32633, name: "WGS 84 / UTM zone 33N", country: "World" },
  { code: 32634, name: "WGS 84 / UTM zone 34N", country: "World" },
  { code: 32635, name: "WGS 84 / UTM zone 35N", country: "World" },
  { code: 32636, name: "WGS 84 / UTM zone 36N", country: "World" },
];

export const Timezones: TimezoneItem[] = [
  { label: '(UTC -10:00) Honolulu', offset: -10 },                                                    // Hawaii Standard Time (USA)
  { label: '(UTC -09:00) Anchorage', offset: -9 },                                                    // Alaska Standard Time (USA)
  { label: '(UTC -08:00) Los Angeles, Seattle, Vancouver', offset: -8 },                              // Pacific Standard Time (USA)
  { label: '(UTC -07:00) Calgary, Denver, Salt Lake City', offset: -7 },                              // Mountain Standard Time (USA)
  { label: '(UTC -06:00) Chicago, Winnipeg', offset: -6 },                                            // Central Standard Time (USA)
  { label: '(UTC -05:00) Boston, Montreal, New York City, Toronto', offset: -5 },                     // Eastern Standard Time (USA)
  { label: '(UTC -04:00) Halifax, Santiago', offset: -4 },                                            // Halifax, Santiago
  { label: '(UTC -03:00) Buenos Aires, Sao Paulo', offset: -3 },                                      // Brazil Time (Brazil)
  { label: '(UTC -02:00) Nuuk', offset: -2 },                                                         // South Georgia Time
  { label: '(UTC -01:00) Azores', offset: -1 },                                                       // Azores
  { label: '(UTC +00:00) Dublin, London, Antarctic/Troll', offset: 0 },                               // Greenwich Mean Time (UK)
  { label: '(UTC +01:00) Bern, Oslo, Paris, Prague, Rome, Stockholm, Vienna, Warsaw', offset: 1 },    // Central European Time
  { label: '(UTC +02:00) Bucharest, Helsinki, Kyiv, Sofia', offset: 2 },                              // Eastern European Time
  { label: '(UTC +03:00) Doha, Istanbul, Riyadh', offset: 3 },                                        // Turkey Time (Turkey)
  { label: '(UTC +04:00) Dubai, Tbilisi', offset: 4 },                                                // Gulf Standard Time (UAE)
  { label: '(UTC +05:00) Astana, Karachi, Tashkent', offset: 5 },                                     // Pakistan Standard Time (Pakistan)
  { label: '(UTC +06:00) Dhaka', offset: 6 },                                                         // Bangladesh Standard Time (Bangladesh)
  { label: '(UTC +07:00) Bangkok, Jakarta', offset: 7 },                                              // Indochina Time (Thailand)
  { label: '(UTC +08:00) Beijing, Kuala Lumpur, Perth, Shanghai', offset: 8 },                        // China Standard Time (China)
  { label: '(UTC +09:00) Seoul, Tokyo', offset: 9 },                                                  // Japan Standard Time (Japan)
  { label: '(UTC +10:00) Brisbane, Canberra, Melbourne, Sydney', offset: 10 },                        // Australian Eastern Time (Australia)
  { label: '(UTC +11:00) Micronesia', offset: 11 },                                                   // Micronesia
  { label: '(UTC +12:00) Auckland, Christchurch', offset: 12 },                                       // New Zealand Standard Time (New Zealand)
];